import request from './request';
import type { JsonSerializable } from './types';

export const httpPost = <T>(
    url: string,
    data?: Record<string, JsonSerializable>,
    options: RequestInit = {},
): Promise<T> => request<T>(url, { method: 'POST', body: JSON.stringify(data), ...options });
